import { Dialog } from "@headlessui/react";
import { X } from "lucide-react";

import { useTrack } from "@/analytics/events";
import { BUY_PANEL } from "@/views/shared/buyPanelContent";
import useLayoutStore from "@/stores/useLayoutStore";

const TITLE = "A note on pricing";
const PARAGRAPHS = [
  "Matic is built to get better over time. In the last six months alone, we’ve shipped 24 major releases, delivering new capabilities, better navigation, a simpler app, and more.",
  "Delivering these improvements while keeping processing on-device requires advanced chips and memory components, whose costs have risen significantly in the past year.",
  "As of September 15, Matic is $1,495.",
  "What doesn’t change: the robot you buy today will keep getting better.",
];
const CTA_LABEL = "SHOP MATIC";

export default function PricingNoteModal() {
  const isOpen = useLayoutStore((state) => state.isPricingNoteModalOpen);
  const closeModal = useLayoutStore((state) => state.closePricingNoteModal);
  const track = useTrack();

  const handleShopClick = () => {
    track("cta_clicked", { cta: "shop", href: BUY_PANEL.href });
    closeModal();
  };

  return (
    <Dialog open={isOpen} onClose={closeModal} className="relative z-[100]">
      <div
        className="fixed inset-0 bg-black/30 backdrop-blur-[5px]"
        aria-hidden
      />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-[100dvh] items-center justify-center p-[10px]">
          <Dialog.Panel className="relative flex max-h-[calc(100dvh-20px)] w-full max-w-[370px] flex-col overflow-hidden rounded-[34px] bg-white ring-[3px] ring-inset ring-white/40 lg:max-w-[550px]">
            <div className="flex shrink-0 flex-col gap-[16px] px-[30px] pt-[30px]">
              <div className="flex items-start justify-between gap-[8px]">
                <Dialog.Title className="font-ppMori text-[26px] font-semibold leading-[36px] tracking-[-0.56px] text-[#333]">
                  {TITLE}
                </Dialog.Title>
                <button
                  type="button"
                  onClick={closeModal}
                  aria-label="Close"
                  className="-mr-[4px] mt-[3px] flex h-[28px] w-[28px] shrink-0 items-center justify-center rounded-full text-[#333] transition-opacity hover:opacity-70"
                >
                  <X size={20} strokeWidth={1.5} />
                </button>
              </div>
              <div className="h-px w-full bg-[#dbdbdb]" />
            </div>
            <div className="flex min-h-0 flex-1 flex-col gap-[16px] overflow-y-auto px-[30px] pt-[16px] font-ppMori tracking-[-0.32px] text-[#54524e] [&>p]:m-0 [&>p]:text-[16px] [&>p]:leading-[24px]">
              {PARAGRAPHS.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
            <div className="shrink-0 px-[30px] pb-[30px] pt-[28px]">
              <a
                href={BUY_PANEL.href}
                onClick={handleShopClick}
                className="flex h-[56px] w-full items-center justify-center rounded-[50px] border border-black bg-[#1f2022] px-[8px] font-trimMono text-[16px] uppercase leading-[1.6] tracking-[0.48px] text-white no-underline transition-colors hover:bg-white hover:text-[#1f2022]"
              >
                {CTA_LABEL}
              </a>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
